// extracted by mini-css-extract-plugin
export default {"go-up":"goUp_go-up__jbWUy","image":"goUp_image__ZGiL9"};